import { useState } from 'react';
import { TabOptions } from 'types/ManageJobs';

export const tabOptions: string[] = [
  TabOptions.Create,
  TabOptions.ScheduledJobs,
  TabOptions.JobHistory
];

export const useTabs = (initialData: TabOptions) => {
  const [activeTab, setActiveTab] = useState(initialData);

  const showScheduledJobsTab = activeTab === TabOptions.ScheduledJobs
  const showCreateTab = activeTab === TabOptions.Create
  const showJobHistoryTab = activeTab === TabOptions.JobHistory

  return {
    activeTab,
    tabOptions,
    setActiveTab,
    showScheduledJobsTab,
    showCreateTab,
    showJobHistoryTab
  }
};